// چهره‌ی «آوا»، دستیار پشتیبانی پنل: تصویرِ ساده‌ی SVG (روسریِ فیروزه‌ای و هدستِ پشتیبانی)،
// بدونِ فایلِ تصویر و درخواستِ بیرونی. رنگ‌ها ثابت‌اند (همان آبیِ پنل در پوسته‌ی روشن) تا در هر دو پوسته یکسان دیده شود.
import React from "react";

export default function AvaAvatar({ className = "h-10 w-10", online = false }: { className?: string; online?: boolean }) {
  return (
    <span className={`relative inline-block shrink-0 ${className}`}>
      <svg viewBox="0 0 64 64" className="h-full w-full" role="img" aria-label="آوا، دستیار پشتیبانی">
        <defs>
          <linearGradient id="ava-bg" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0" stopColor="#6ea3ed" />
            <stop offset="1" stopColor="#265ba3" />
          </linearGradient>
          <clipPath id="ava-clip"><circle cx="32" cy="32" r="32" /></clipPath>
        </defs>
        <g clipPath="url(#ava-clip)">
          <rect width="64" height="64" fill="url(#ava-bg)" />
          {/* شانه‌ها و مانتو */}
          <path d="M4 66c3-12 13-17 28-17s25 5 28 17z" fill="#1e293b" />
          {/* روسری: روی سر و افتاده تا روی شانه‌ها */}
          <path d="M32 9c-13 0-19 11-19 23 0 9-3 16-8 26 7 4 16 6 27 6s20-2 27-6c-5-10-8-17-8-26 0-12-6-23-19-23z" fill="#6cbfb2" />
          <path d="M32 9c-13 0-19 11-19 23 0 4-.6 8-1.8 12 3-6 5-12 5-19 0-9 6-15 15.8-15.6z" fill="#9ad8cd" />
          {/* صورت */}
          <ellipse cx="32" cy="33.5" rx="10.2" ry="12.2" fill="#f6d7c3" />
          {/* موی جلوی سر زیرِ روسری */}
          <path d="M21.8 30c.6-6.5 4.8-10.4 10.2-10.4S41.6 23.5 42.2 30c-2.2-3.4-5.4-5.2-9-5.6-1.6 2.2-5 4-11.4 5.6z" fill="#4a3426" />
          {/* لبه‌ی روسری دورِ صورت و گره‌ی زیرِ چانه */}
          <path d="M32 18.5c-7.8 0-12.6 6.6-12.6 15 0 8.6 5.6 15.5 12.6 15.5s12.6-6.9 12.6-15.5c0-8.4-4.8-15-12.6-15z" fill="none" stroke="#4fa598" strokeWidth="2.2" />
          <path d="M23 46c3 3.4 6 5 9 5s6-1.6 9-5l3 10c-3.6 2.4-7.6 3.4-12 3.4s-8.4-1-12-3.4z" fill="#5cb1a4" />
          {/* چشم‌ها، ابروها، لبخند، گونه‌ها */}
          <path d="M25.5 29.2q2-1.4 4 0M34.5 29.2q2-1.4 4 0" stroke="#5b4636" strokeWidth="1.1" fill="none" strokeLinecap="round" />
          <ellipse cx="27.6" cy="32.4" rx="1.3" ry="1.6" fill="#2b2118" />
          <ellipse cx="36.4" cy="32.4" rx="1.3" ry="1.6" fill="#2b2118" />
          <circle cx="25.4" cy="37" r="1.9" fill="#f0a8a0" opacity="0.55" />
          <circle cx="38.6" cy="37" r="1.9" fill="#f0a8a0" opacity="0.55" />
          <path d="M28.6 38.6q3.4 2.8 6.8 0" stroke="#b5544d" strokeWidth="1.3" fill="none" strokeLinecap="round" />
          {/* هدستِ پشتیبانی */}
          <path d="M17.5 33c0-10 6.5-16.5 14.5-16.5S46.5 23 46.5 33" stroke="#334155" strokeWidth="2.2" fill="none" strokeLinecap="round" />
          <rect x="15" y="31" width="5" height="8.5" rx="2.4" fill="#334155" />
          <rect x="44" y="31" width="5" height="8.5" rx="2.4" fill="#334155" />
          <path d="M46.5 39.5q0 6.5-8 7.2" stroke="#334155" strokeWidth="1.4" fill="none" strokeLinecap="round" />
          <circle cx="38" cy="46.7" r="1.7" fill="#334155" />
        </g>
      </svg>
      {online ? <span className="absolute bottom-0 left-0 block h-[28%] w-[28%] rounded-full bg-emerald-400 ring-2 ring-slate-900" aria-hidden /> : null}
    </span>
  );
}
